import React, { useEffect } from "react";
import { Dialog, Card, Box, Typography, IconButton, TextField } from "@mui/material";
import PromptMessageImage from "../../assets/promptMessage.png";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import "./Popup.css";
import CloseIcon from '@mui/icons-material/Close';
import { showToast } from "../Toast/CommonToast";

import Checkbox from '@mui/material/Checkbox';
import ReusableButton from "../Reusable/PrimaryButton/PrimaryButton";
import SecondaryButton from "../Reusable/SecondaryButton/SecondaryButton";
import { ReactCompareSlider } from 'react-compare-slider';
import AudioPlayer from 'react-h5-audio-player';
import 'react-h5-audio-player/lib/styles.css';

type LeftContentType = "prompt" | "image" | "script" | "both" | 'none';
type RightContentType = "video" | "image" | "slider" | undefined;
type AIInfluencerType = "AiInfluencer" | "none";




type CommonPopupProps = {
    open: boolean;
    onClose: () => void;
    leftColumnType?: LeftContentType;
    leftPromptText?: string | null;
    leftImageSrc?: string;
    rightColumnType?: RightContentType;
    mainVideo?: string;
    previewImageSrc?: string;
    script?: string;
    aiInfluencer?: AIInfluencerType;
    createAIinfluncer?: any;
    setCreateInfluencer?: any;
    onShowMoreImages?: () => void;
    formData?:{
        age: string
        gender: string
        ethnicity: string
        hair: string
    }
    modelName?: string;
    eventId?: string;
    proccedImages?: (selectedImageIds?: string[]) => void;
    selectionMode?: 'single' | 'multiple';
    originalImage?: string | undefined;
    generatedImage?: string | undefined;
    audioUrl?: string;
};

const CommonPopup = ({
    open,
    onClose,
    leftColumnType,
    leftPromptText,
    leftImageSrc,
    rightColumnType,
    mainVideo,
    previewImageSrc,
    script,
    aiInfluencer,
    createAIinfluncer,
    setCreateInfluencer,
    onShowMoreImages,
    formData,
    eventId,
    proccedImages,
    modelName,
    selectionMode = 'multiple',
    originalImage,
    generatedImage,
    audioUrl
}: CommonPopupProps) => {
    const [fullImageOpen, setFullImageOpen] = React.useState(false);
    const [fullImageSrc, setFullImageSrc] = React.useState<string | null>(null);
    const [page, setPage] = React.useState(0);
    const [selectedImageIds, setSelectedImageIds] = React.useState<string[]>([]);
    const [loadingStates, setLoadingStates] = React.useState<{[key: string]: boolean}>({});
    // Constants for pagination
    const IMAGES_PER_PAGE = selectionMode === "single" ? 3 : 4;

    useEffect(() => {
      // Reset selection when images or popup open state changes
      if (open && Array.isArray(createAIinfluncer)) {
        setSelectedImageIds([]);
        setPage(0);
        // Initialize loading states for images that don't have URLs yet
        const initialLoadingStates: {[key: string]: boolean} = {};
        createAIinfluncer.forEach(item => {
          const imageUrl = item.url || item.imageUrl || (item.inputData && (item.inputData.url || item.inputData.imageUrl));
          if (!imageUrl) {
            initialLoadingStates[item._id] = true;
          }
        });
        setLoadingStates(initialLoadingStates);
      }
    }, [open, createAIinfluncer]);

    // Update loading states when images are loaded
    useEffect(() => {
      if (Array.isArray(createAIinfluncer)) {
        setLoadingStates(prev => {
          const updated = { ...prev };
          createAIinfluncer.forEach(item => {
            const imageUrl = item.url || item.imageUrl || (item.inputData && (item.inputData.url || item.inputData.imageUrl));
            if (imageUrl && updated[item._id]) {
              delete updated[item._id]; // Remove loading state when image is available
            }
          });
          return updated;
        });
      }
    }, [createAIinfluncer]);

    const handleDownload = async () => {
        let fileUrl = "";
        let fileName = "";

        if (rightColumnType === "video" && mainVideo) {
            fileUrl = mainVideo;
        } else if (rightColumnType === "image" && previewImageSrc) {
            fileUrl = previewImageSrc;
        } else if (rightColumnType === "slider") {
            if (originalImage && generatedImage) {
                // Download both images in the slider
                fileUrl = originalImage; // Default to original image
                fileName = originalImage.split('/').pop()?.split('?')[0] || "original_image";
                const generatedBlob = await fetch(generatedImage).then(res => res.blob());
                const generatedUrl = window.URL.createObjectURL(generatedBlob);
                
                // Create a zip or similar structure if needed, here we just download the original
                const a = document.createElement("a");
                a.href = generatedUrl;
                a.download = generatedImage.split('/').pop()?.split('?')[0] || "generated_image";
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                window.URL.revokeObjectURL(generatedUrl);
            }
        } 
        
        else {
            showToast("No downloadable content.", "error");
            return;
        }

        // Check if the URL is valid and accessible
        if (!fileUrl.startsWith("http://") && !fileUrl.startsWith("https://") && !fileUrl.startsWith("/")) {
            showToast("Invalid file URL for download.", "error");
            return;
        }

        fileName = fileUrl.split('/').pop()?.split('?')[0] || "download";

        try {
            const response = await fetch(fileUrl);
            if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
            const blob = await response.blob();

            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = fileName;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            window.URL.revokeObjectURL(url);
        } catch (error: any) {
            showToast("Download failed: " + (error?.message || error), "error");
            console.error("Download failed:", error);
        }
    };

    const handleCopiedText = () => {
        let copiedText = "";
        let copiedType = "";

        if (leftPromptText) {
            copiedText = leftPromptText;
            copiedType = "Prompt";
        } else if (script) {
            copiedText = script;
            copiedType = "Script";
        }

        if (copiedText) {
            navigator.clipboard.writeText(copiedText);
            showToast(`${copiedType} copied to clipboard`, "success");
        }
    };

    // Get current page images with proper indexing
//    const IMAGES_PER_PAGE = 3;
console.log("createAIinfluncer", createAIinfluncer)
const getCurrentPageImages = () => {
    if (!Array.isArray(createAIinfluncer)) return [];
    const startIndex = page * IMAGES_PER_PAGE;
    const endIndex = startIndex + IMAGES_PER_PAGE;
    const pageImages = createAIinfluncer.slice(startIndex, endIndex);
    // Always return exactly 3 slots (some may be empty for loading)
    const slots = Array(IMAGES_PER_PAGE).fill(null);
    pageImages.forEach((img, idx) => {
        slots[idx] = img;
    });
    return slots;
};


    // Handle image selection
    const handleImageSelection = (imageId: string) => {
        if (selectionMode === 'single') {
            // For single selection, replace the entire array
            setSelectedImageIds([imageId]);
        } else {
            // For multiple selection, toggle the selection
            setSelectedImageIds((prev) => {
                if (prev.includes(imageId)) {
                    return prev.filter((id) => id !== imageId);
                } else {
                    return [...prev, imageId];
                }
            });
        }
    };

    // Handle proceed with selected images
    const handleProceed = (selectedImageIds: string[]) => {
        if (proccedImages && selectedImageIds.length > 0) {
            console.log('Proceeding with selected image IDs:', selectedImageIds);
            proccedImages(selectedImageIds);
        }
    };

    // Loading placeholder component
    const LoadingPlaceholder = ({ slotIndex }: { slotIndex: number }) => (
        <Box
            sx={{
                width: { xs: 100, md: 230 },
                height: { xs: 180, md: 250 },
                mb: { xs: 2, md: 0 },
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                background: 'transparent',
                backgroundSize: '20px 20px',
                backgroundPosition: '0 0, 0 10px, 10px -10px, -10px 0px',
                borderRadius: 12,
                border: 'none',
                animation: 'pulse 2s ease-in-out infinite alternate',
            }}
        >
            <Typography variant="body2" color="textSecondary">
                Loading...
            </Typography>
        </Box>
    );

    // Get current page images for rendering
    const currentImageSlots = getCurrentPageImages();
    // Enable Show More Images button if any image has requestStatus: 'OK'
    const showMoreEnabled = currentImageSlots.some(img => img?.requestStatus === 'OK');
    console.log("currentImageSlots", currentImageSlots, currentImageSlots)

    return (
        <>
            {open && (
                <Box sx={{ position: 'relative', width: '100%' }}>
                    <Dialog
                      open={open}
                      onClose={(event, reason) => {
                        if (reason !== "backdropClick") {
                          onClose();
                        }
                      }}
                      className="PopupContainer"
                      maxWidth={aiInfluencer === 'AiInfluencer' ? 'md' : 'md'}
                      fullWidth
                    >
 
                        {aiInfluencer === 'AiInfluencer' ? (
                            <div className="aiInfluncerContainer">
                                <Box className="PopupHeader">
                                    <IconButton onClick={onClose} className="PopupCloseButton">
                                        <CloseIcon />
                                    </IconButton>
                                </Box>
                                <Box p={4}>
                                    <Typography variant="h6" gutterBottom className="influencerTitle">
                                       Choose your preferred AI variant to continue.
                                    </Typography>
                                    <Typography variant="body2" className="influencerDescription" gutterBottom>
                                       {`This visual aligns with your given image ${selectionMode === 'single' ? 'characteristics' : 'variants'}.`}
                                    </Typography>
                                    
                                    {/* Images Grid - Always show 3 slots */}
                                    <Box
                                        display="flex"
                                        flexWrap="nowrap"
                                        flexDirection="row"
                                        justifyContent="center"
                                        alignItems="center"
                                        gap={3}
                                        my={3}
                                    >
                                        {currentImageSlots.map((img, slotIdx) => {
                                            const actualIndex = page * IMAGES_PER_PAGE + slotIdx;
                                            
                                            if (img) {
                                                const imageUrl = img.url || img.imageUrl || (img.inputData && (img.inputData.url || img.inputData.imageUrl)) || '';
                                                const imageId = img._id;
                                                const isSelected = selectedImageIds.includes(imageId);
                                                const isLoading = loadingStates[imageId] || !imageUrl;
                                                
                                                if (isLoading) {
                                                    return <LoadingPlaceholder key={`loading-${actualIndex}`} slotIndex={actualIndex} />;
                                                }
                                                
                                                return (
                                                    <Box
                                                        key={`image-${imageId}-${actualIndex}`}
                                                        position="relative"
                                                        sx={{
                                                            width: { xs: 100, md: 230 },
                                                            height: { xs: 180, md: 250 },
                                                            mb: { xs: 2, md: 0 },
                                                            display: 'flex',
                                                            flexDirection: 'column',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                        }}
                                                    >
                                                        <img
                                                            src={imageUrl}
                                                            alt={`AI Variant ${actualIndex + 1}`}
                                                            style={{
                                                                width: '100%',
                                                                height: '100%',
                                                                borderRadius: 12,
                                                                objectFit: 'cover',
                                                                border: isSelected ? '3px solid #8B5CF6' : '2px solid transparent',
                                                                transition: 'border 0.2s',
                                                                cursor: 'pointer',
                                                                boxShadow: isSelected ? '0 0 10px rgba(139, 92, 246, 0.3)' : 'none',
                                                            }}
                                                            onClick={() => handleImageSelection(imageId)}
                                                        />
                                                        <Checkbox
                                                            checked={isSelected}
                                                            onChange={() => handleImageSelection(imageId)}
                                                            className="selectionCheckbox"
                                                            sx={{ 
                                                                position: 'absolute', 
                                                                top: 8, 
                                                                right: 8, 
                                                                background: 'rgba(255,255,255,0.9)', 
                                                                borderRadius: '50%',
                                                                '&.Mui-checked': {
                                                                    color: '#8B5CF6',
                                                                },
                                                            }}
                                                        />
                                                    </Box>
                                                );
                                            } else {
                                                // Empty slot - show loading placeholder if we're expecting more images
                                                const totalExpected = createAIinfluncer?.length || 0;
                                                const shouldShowLoading = actualIndex < totalExpected || totalExpected === 0;
                                                
                                                return shouldShowLoading ? 
                                                    <LoadingPlaceholder key={`empty-loading-${actualIndex}`} slotIndex={actualIndex} /> :
                                                    <Box
                                                        key={`empty-${actualIndex}`}
                                                        sx={{
                                                            width: { xs: 100, md: 230 },
                                                            height: { xs: 180, md: 250 },
                                                            mb: { xs: 2, md: 0 },
                                                        }}
                                                    />;
                                            }
                                        })}
                                    </Box>

                                    {/* Action Buttons */}
                                    <Box display="flex" justifyContent={selectionMode ? "flex-end":"space-between"} alignItems="center" mt={2} gap={2}>
                                        {/* {selectionMode === 'multiple' && (
                                            <Box display="flex" gap={2} className="width100">
                                            <SecondaryButton
                                                onClick={() => setPage(page - 1)}
                                                icon={<ArrowBackIosIcon />}
                                                disabled={page === 0}
                                            >
                                                Previous
                                            </SecondaryButton>
                                               <SecondaryButton
                                                onClick={() => setPage(page + 1)}
                                                icon={<ArrowForwardIosIcon />}
                                                disabled={!hasNextPage()}
                                            >
                                                Next
                                            </SecondaryButton>
                                        </Box>)} */}

                                        {/* Right Buttons */}
                                        <Box display="flex" gap={2} className="width100 endButton">
                                           
                                             {/* Show More Images Button - Only show if onShowMoreImages is provided */}
                                            {onShowMoreImages && (
                                                <SecondaryButton onClick={onShowMoreImages} disabled={!showMoreEnabled}>
                                                    {`Show More Images (${selectionMode === 'single' ? '75' : '100'} Credits)`}
                                                </SecondaryButton>
                                            )}
                                            <ReusableButton
                                                disabled={selectedImageIds.length === 0 || !showMoreEnabled}
                                                onClick={() => handleProceed(selectedImageIds)}
                                            >
                                                Proceed ({selectedImageIds.length})
                                            </ReusableButton>
                                        </Box>
                                    </Box>


                                    {/* Debug Info - Remove in production */}
                                    {/* {process.env.NODE_ENV === 'development' && (
                                        <Box mt={2} p={2} bgcolor="rgba(0,0,0,0.1)" borderRadius={1}>
                                            <Typography variant="caption" display="block">
                                                Debug: Selected IDs: {JSON.stringify(selectedImageIds)}
                                            </Typography>
                                            <Typography variant="caption" display="block">
                                                Total Images: {createAIinfluncer?.length || 0}
                                            </Typography>
                                            <Typography variant="caption" display="block">
                                                Current Page: {page + 1} / {getTotalPages()}
                                            </Typography>
                                            <Typography variant="caption" display="block">
                                                Selection Mode: {selectionMode}
                                            </Typography>
                                        </Box>
                                    )} */}
                                </Box>
                            </div>
                        ) : (
                            <>
                                <Box className="PopupHeader">
                                    <IconButton onClick={onClose} className="PopupCloseButton">
                                        <CloseIcon />
                                    </IconButton>
                                </Box>
                                <Box className="PopupContent" sx={{ display: 'flex' }}>
                                    {leftColumnType && leftColumnType !== "none" && (
                                        <Box className="PopupContentLeft" sx={{ flex: '0 0 40%', p: 2 }}>
                                            {(leftColumnType === "prompt" || leftColumnType === "both") && (
                                                <Box
                                                    className="PopupContentLeftHeader"
                                                    sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}
                                                >
                                                    <div className="PopupContentLeftHeaderTitle" style={{ display: 'flex', alignItems: 'center' }}>
                                                        <img src={PromptMessageImage} alt="PromptIcon" className="PromptIcon" />
                                                        <Typography variant="h6" className="PopupTitle" sx={{ ml: 1 }}>
                                                            Prompt Details
                                                        </Typography>
                                                    </div>
                                                    <IconButton onClick={handleCopiedText}>
                                                        <ContentCopyIcon fontSize="small" />
                                                    </IconButton>
                                                </Box>
                                            )}

                                            {/* Prompt Text */}
                                            {(leftColumnType === "prompt" || leftColumnType === "both") && (
                                                <Box className="PromptContainer" sx={{ mb: 2 }}>
                                                    <TextField
                                                        multiline
                                                        rows={4}
                                                        variant="outlined"
                                                        fullWidth
                                                        className="textField"
                                                        value={leftPromptText}
                                                        InputProps={{
                                                            readOnly: true,
                                                        }}
                                                    />
                                                </Box>
                                            )}

                                            {/* script */}
                                            {(leftColumnType === "script") && (
                                                <Box
                                                    className="PopupContentLeftHeader"
                                                    sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}
                                                >
                                                    <div className="PopupContentLeftHeaderTitle" style={{ display: 'flex', alignItems: 'center' }}>
                                                        <img src={PromptMessageImage} alt="PromptIcon" className="PromptIcon" />
                                                        <Typography variant="h6" className="PopupTitle" sx={{ ml: 1 }}>
                                                            Script Details
                                                        </Typography>
                                                    </div>
                                                    <IconButton onClick={handleCopiedText}>
                                                        <ContentCopyIcon fontSize="small" />
                                                    </IconButton>
                                                </Box>
                                            )}

                                            {/* Prompt Text */}
                                            {(leftColumnType === "script") && (
                                                <Box className="PromptContainer" sx={{ mb: 2 }}>
                                                    <TextField
                                                        multiline
                                                        rows={4}
                                                        variant="outlined"
                                                        fullWidth
                                                        className="textField"
                                                        value={script || ""}
                                                        InputProps={{
                                                            readOnly: true,
                                                        }}
                                                    />
                                                </Box>
                                            )}

                                            {/* Header for image */}
                                            {(leftColumnType === "image" || leftColumnType === "script" || leftColumnType === "both") && (
                                                <>
                                                    <Box className="PopupContentLeftHeader" sx={{ mb: 1 }}>
                                                        <Typography variant="h6" className="PopupTitle">
                                                            Uploaded Image
                                                        </Typography>
                                                    </Box>
                                                </>
                                            )}

                                            {/* Image */}
                                            {(leftColumnType === "image" || leftColumnType === "script" || leftColumnType === "both") && leftImageSrc && (
                                                <Box className="ImageContainers">
                                                    <img
                                                        src={leftImageSrc}
                                                        alt="PromptImage"
                                                        className="PromptImage"
                                                        style={{ maxWidth: '100%', borderRadius: 4, cursor: 'pointer' }}
                                                        onClick={() => {
                                                            setFullImageSrc(leftImageSrc);
                                                            setFullImageOpen(true);
                                                        }}
                                                    />
                                                </Box>
                                            )}

                                            {audioUrl && (
                                                <Box className="AudioContainer">
                                                    <Typography variant="h6" className="PopupTitle">
                                                        Audio
                                                    </Typography>
                                                    <AudioPlayer
                                                        autoPlay={false}
                                                        src={audioUrl}
                                                        className="AudioPlayer"
                                                       showJumpControls={false}
                                                       showSkipControls={false}
                                                       timeFormat="mm:ss"
                                                       layout="horizontal-reverse"
                                                      
                                                    />
                                                </Box>
                                            )}
                                        </Box>
                                    )}

                                    {rightColumnType && (
                                        <Box
                                        className="PopupContentRight"
                                        sx={{
                                            flex: !leftColumnType ? '0 0 60%' : '1',
                                            p: 0,
                                            height: '100%',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            flexDirection: 'column',
                                        }}
                                    >
                                        <Card
                                            className="videoCard"
                                            sx={{
                                                width: '100%',
                                                height: '100%',
                                                position: 'relative',
                                                overflow: 'hidden',
                                            }}
                                        >
                                            {rightColumnType === "video"  ?  (
                                                <video
                                                    className="videoPlayer"
                                                    controls
                                                    src={mainVideo}
                                                    autoPlay={false}
                                                    
                                                />
                                            ) : (rightColumnType === "image" && (
                                                 <img
                                                    src={previewImageSrc}
                                                    alt="PromptImage"
                                                    className="outPutImage"
                                                    onClick={() => {
                                                        setFullImageSrc(previewImageSrc || null);
                                                        setFullImageOpen(true);
                                                    }}
                                                />
                                            ))}
                                            {rightColumnType === "slider" && (
                                                <Box className="sliderContainer">
                                                    <ReactCompareSlider
                                                      itemOne={<img src={originalImage} alt="Original" className="silderImage" onClick={
                                                        () => {
                                                            setFullImageSrc(originalImage || null);
                                                            setFullImageOpen(true);
                                                        }
                                                      }/> }
                                                      itemTwo={<img src={generatedImage} alt="Generated" className="silderImage"  onClick={
                                                        () => {
                                                            setFullImageSrc(generatedImage || null);
                                                            setFullImageOpen(true);
                                                        }
                                                      }/>}
                                                      style={{ width: '100%', height: 600 }}

                                                    />
                                                </Box>
                                            )}

                                            <Box className="videoHeader">
                                                <IconButton onClick={handleDownload}>
                                                    <img
                                                        src={'/assets/DownloadIcon.svg'}
                                                        alt="downloadIcon"
                                                        className="downloadIcon"
                                                    />
                                                </IconButton>
                                            </Box>
                                        </Card>
                                    </Box>
                                    )}
                                </Box>
                                {/* Full Image Dialog */}
                                <Dialog open={fullImageOpen} onClose={() => setFullImageOpen(false)} maxWidth="md" fullWidth>
                                    <Box sx={{ position: 'relative' }}>
                                        <IconButton
                                            onClick={() => setFullImageOpen(false)}
                                            className="CloseButton"
                                        >
                                            <CloseIcon />
                                        </IconButton>
                                        <img
                                            src={fullImageSrc || ""}
                                            alt="Full View"
                                            className="fullImage"
                                        />
                                    </Box>
                                </Dialog>
                            </>
                        )}
                    </Dialog>
                </Box>
            )}
            
            {/* Add CSS for loading animation */}
            <style>
                {`
                    @keyframes pulse {
                        0% { opacity: 0.6; }
                        100% { opacity: 1; }
                    }
                `}
            </style>
        </>
    );
};

export default CommonPopup;